export function UserGroupIcons(props) {
  return (
    <svg
      width="19"
      height="16"
      viewBox="0 0 19 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.5 3.5C12.5 5.15685 11.1569 6.5 9.5 6.5C7.84315 6.5 6.5 5.15685 6.5 3.5C6.5 1.84315 7.84315 0.5 9.5 0.5C11.1569 0.5 12.5 1.84315 12.5 3.5Z"
        fill="currentColor"
      />
      <path
        d="M17.5 5.5C17.5 6.60457 16.6046 7.5 15.5 7.5C14.3954 7.5 13.5 6.60457 13.5 5.5C13.5 4.39543 14.3954 3.5 15.5 3.5C16.6046 3.5 17.5 4.39543 17.5 5.5Z"
        fill="currentColor"
      />
      <path
        d="M13.5 12.5C13.5 10.2909 11.7091 8.5 9.5 8.5C7.29086 8.5 5.5 10.2909 5.5 12.5V15.5H13.5V12.5Z"
        fill="currentColor"
      />
      <path
        d="M5.5 5.5C5.5 6.60457 4.60457 7.5 3.5 7.5C2.39543 7.5 1.5 6.60457 1.5 5.5C1.5 4.39543 2.39543 3.5 3.5 3.5C4.60457 3.5 5.5 4.39543 5.5 5.5Z"
        fill="currentColor"
      />
      <path
        d="M15.5 15.5V12.5C15.5 11.4459 15.2282 10.4552 14.7507 9.59432C14.9902 9.53275 15.2413 9.5 15.5 9.5C17.1569 9.5 18.5 10.8431 18.5 12.5V15.5H15.5Z"
        fill="currentColor"
      />
      <path
        d="M4.24926 9.59432C3.77185 10.4552 3.5 11.4459 3.5 12.5V15.5H0.5V12.5C0.5 10.8431 1.84315 9.5 3.5 9.5C3.75871 9.5 4.00977 9.53275 4.24926 9.59432Z"
        fill="currentColor"
      />
    </svg>
  );
}
